export const Faqsdata = [
    { id: 1, title: "How To Insert All The Plugins?" },
    { id: 2, title: "How Can I contact?", },
    { id: 3, title: "Can I use this Plugins in Another Template?", },
    { id: 4, title: "How Can I Add another page in Template?", },
    { id: 5, title: "It is Easy to Customizable?", },
    { id: 6, title: "How can I download This template?", },
]